var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.phoneClass,attrs:{"href":'tel:'+_vm.phoneNumber}},[_c('i',{staticClass:"el-icon-phone-outline"}),_vm._v(" "),_c('span',{staticClass:"phoneNumber"},[_vm._v("\n        "+_vm._s(_vm.serverMobile)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6cc2580","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Phone/Phone.vue
// module id = null
// module chunks = 